var _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectionSalesGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.5L4.27294 7.8L10.2932 9.8L11.1962 4.8L14.106 3.4L17.0158 2M17.0158 2L16.0124 4M17.0158 2L14.5073 1.5",
    stroke: "#9296AC",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.19995,
    cy: 7.90002,
    r: 1,
    fill: "white",
    stroke: "#9296AC",
    strokeWidth: 0.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.2,
    cy: 9.7998,
    r: 1,
    fill: "white",
    stroke: "#9296AC",
    strokeWidth: 0.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.3,
    cy: 4.8999,
    r: 1,
    fill: "white",
    stroke: "#9296AC",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectionSalesGray);
export default __webpack_public_path__ + "static/media/projectionSalesGray.1792e395eafe3908339f6a0f52b8df89.svg";
export { ForwardRef as ReactComponent };